export default {
    getCmpProjHome (state) {
        return state.cmpProjHome
    },
    getCmpProjHomeLoadStatus (state) {
        return state.cmpProjHomeLoadStatus
    },

    getCmpProjHasChangeForInputBarStatus (state) {
        return state.cmpProjHasChangeForInputBarStatus
    },

    /** 一覧案件情報更新 **/
    getChangeCmpProjInfoCommon (state) {
        return state.changeCmpProjInfoCommon
    },
    getChangeCmpProjInfoCommonStatus (state) {
        return state.changeCmpProjInfoCommonStatus
    },

    /** 案件情報 **/
    getCmpProjOperat (state) {
        return state.cmpProjOperat
    },
    getCmpProjInfo (state) {
        return state.cmpProjInfo
    },
    getSaveCmpProjInfoStatus (state) {
        return state.saveCmpProjInfoStatus
    },
    getCmpProjInfoLoadStatus (state) {
        return state.cmpProjInfoLoadStatus
    },
    getCmpProjDelStatus (state) {
        return state.cmpProjDelStatus
    },
    getCmpProjOffStatus (state) {
        return state.cmpProjOffStatus
    },

    // 公開
    getCmpProjPubliced (state) {
        return state.cmpProjPubliced
    },
    getCmpProjPublicStatus (state) {
        return state.cmpProjPublicStatus
    },

    // 単価公開
    getCmpProjPricePubliced (state) {
        return state.cmpProjPricePubliced
    },
    getCmpProjPricePubStatus (state) {
        return state.cmpProjPricePubStatus
    },

    // 備考
    getCmpProjNoted (state) {
        return state.cmpProjNoted
    },
    getCmpProjNoteStatus (state) {
        return state.cmpProjNoteStatus
    },
    // 言語分析
    getCmpLangGraph (state) {
        return state.cmpLangGraph.data || {}
    },
    getCmpLangGraphLoadStatus (state) {
        return state.cmpLangGraphLoadStatus
    }
}

